export default __webpack_public_path__ + "static/media/img_bars.44ad076b.svg";